/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'

export default {
  sendFormData ({ commit }, item) {

    console.log('item', item)

    return new Promise((resolve, reject) => {
      axios
        .post('/setEncuestaSatisRequest', {listaPregunta: item}, {
          headers: {
            //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            'Content-type': 'application/json; charset=utf-8',
            'Access-Control-Allow-Origin': '*'
          }
        })
        .then(response => {
          console.log('sendFormData ', response.data) 

          if (response.data.nuOK === 0) {
            resolve(response.data)
          } else {
            reject(null)
          } 
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
